import { IS_GUEST } from "./types";
import { checkClientManageLifeTime } from "@/helpers/authenticate";

export default {
  [IS_GUEST]: () => {
    const isAuthClient = checkClientManageLifeTime();
    return !isAuthClient;
  },
};
